import { baseConfigurations, LOCK_INFO_PATH_PATTERN, lockInfoConfiguration } from './constants';

export const getIncludeByPath = pathname => {
  if (LOCK_INFO_PATH_PATTERN.test(pathname)) {
    return lockInfoConfiguration;
  }

  return baseConfigurations;
};
